import React, { useState } from 'react';
import { FiPlus, FiTool } from 'react-icons/fi';
import ProductsSidebar from '../components/ProductsSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function MRP() {
  const [data, setData] = useLocalState('mrp_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'desc' });

  const handleAdd = (newData) => setData([{ ...newData, status: 'Draft' }, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <ProductsSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiTool className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Manufacturing Orders ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('product')} className="p-2 border border-black text-left cursor-pointer">Product to manufacture</th>
                <th onClick={() => handleSort('qty')} className="p-2 border border-black text-center cursor-pointer">Qty</th>
                <th onClick={() => handleSort('start')} className="p-2 border border-black text-center cursor-pointer">Start Date</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.ref}</td>
                  <td className="p-2 border border-black">{row.product}</td>
                  <td className="p-2 border border-black text-center font-medium">{row.qty}</td>
                  <td className="p-2 border border-black text-center">{row.start}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-gray-100 px-2 py-0.5 rounded border">{row.status}</span></td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="5" className="p-4 text-center text-gray-500">No manufacturing orders.</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add MO" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'product', label: 'Product Name' }, { name: 'qty', label: 'Quantity' }, { name: 'start', label: 'Start Date' }
        ]} />
      </div>
    </div>
  );
}